<template>
  <section class="change-lang-page">
    <div class="radio-list">
      <label class="radio-row">
        <input v-model="selectedLang" type="radio" value="kz" />
        <span>{{ t('kaz_lang') }}</span>
      </label>
      <label class="radio-row">
        <input v-model="selectedLang" type="radio" value="ru" />
        <span>{{ t('rus_lang') }}</span>
      </label>
    </div>

    <div class="actions">
      <button class="change-lang-btn" type="button" @click="saveLang">
        {{ t('change_lang_btn') }}
      </button>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { useLangStore } from '@/stores/lang';
import { useTopbarStore } from '@/stores/topbar';

const router = useRouter();
const { t } = useI18n();
const langStore = useLangStore();
const topbarStore = useTopbarStore();

const selectedLang = ref(langStore.translation || 'ru');

function saveLang() {
  langStore.changeLang(selectedLang.value);
  router.push('/settings');
}

onMounted(() => {
  topbarStore.setTitle(t('change-lang'));
  topbarStore.addButton({
    type: 'left',
    icon: 'keyboard_backspace',
    action: () => router.push('/settings')
  });
});
</script>

<style scoped>
.change-lang-page {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
}

.radio-list {
  background: #fff;
}

.radio-row {
  height: 44px;
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #cfcfcf;
  padding: 0 16px;
  gap: 12px;
}

.actions {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.change-lang-btn {
  width: min(650px, 100%);
  min-height: 36px;
  border: none;
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  background: #36b453;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.24);
}
</style>
